import BecomeTrainerApplyComponent from "../../components/become-trainer/become-trainer-apply"

const BecomeTrainerApplyPage = () => <BecomeTrainerApplyComponent />

export default BecomeTrainerApplyPage;